import produce from "immer";
import { ReconciliationActions } from ".";
import { IStoreState } from "../initialStoreState";
import { initialReconciliationState } from "./reconciliation.types";
import {
  CLEAR_RECONCILIATION_STATE,
  FETCH_AGENCY_BILL_RECONCILIATION_LIST_FAILED,
  FETCH_AGENCY_BILL_RECONCILIATION_LIST_PROGRESS,
  FETCH_AGENCY_BILL_RECONCILIATION_LIST_SUCCESS,
  FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_FAILED,
  FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_PROGRESS,
  FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_SUCCESS,
  FETCH_RECON_AGENCY_BILL_LIST_FAILED,
  FETCH_RECON_AGENCY_BILL_LIST_PROGRESS,
  FETCH_RECON_AGENCY_BILL_LIST_SUCCESS,
  FETCH_RECON_CUSTOMER_PAYABLE_LIST_FAILED,
  FETCH_RECON_CUSTOMER_PAYABLE_LIST_PROGRESS,
  FETCH_RECON_CUSTOMER_PAYABLE_LIST_SUCCESS,
  FETCH_RECON_DIRECT_BILL_LIST_FAILED,
  FETCH_RECON_DIRECT_BILL_LIST_PROGRESS,
  FETCH_RECON_DIRECT_BILL_LIST_SUCCESS,
  UPDATE_BILL_PAYMENT_RECONCILIATION_STATUS,
  UPDATE_INVOICE_PAYMENT_TRANSACTION_RECONCILIATION_STATUS,
} from "./reconciliationActions";
import { LoadState } from "../../constants/enums";

export const reconciliationReducer = (
  state: IStoreState["reconciliation"] = initialReconciliationState,
  action: ReconciliationActions
) => {
  switch (action.type) {
    case FETCH_RECON_AGENCY_BILL_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.agencyBill.loading = LoadState.InProgress;
        draftState.agencyBill.list = [];
        draftState.agencyBill.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_RECON_AGENCY_BILL_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.agencyBill.loading = LoadState.Loaded;
        draftState.agencyBill.list = data;
        draftState.agencyBill.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_RECON_AGENCY_BILL_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.agencyBill.loading = LoadState.InProgress;
        draftState.agencyBill.list = [];
        draftState.agencyBill.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_AGENCY_BILL_RECONCILIATION_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.agencyBillReconciliation.loading = LoadState.InProgress;
        draftState.agencyBillReconciliation.list = [];
      });
      return newState;
    }
    case FETCH_AGENCY_BILL_RECONCILIATION_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.agencyBillReconciliation.loading = LoadState.Loaded;
        draftState.agencyBillReconciliation.list = data;
      });
      return newState;
    }
    case FETCH_AGENCY_BILL_RECONCILIATION_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.agencyBillReconciliation.loading = LoadState.InProgress;
        draftState.agencyBillReconciliation.list = [];
      });
      return newState;
    }
    case FETCH_RECON_DIRECT_BILL_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.directBill.loading = LoadState.InProgress;
        draftState.directBill.list = [];
        draftState.directBill.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_RECON_DIRECT_BILL_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.directBill.loading = LoadState.Loaded;
        draftState.directBill.list = data;
        draftState.directBill.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_RECON_DIRECT_BILL_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.directBill.loading = LoadState.InProgress;
        draftState.directBill.list = [];
        draftState.directBill.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_RECON_CUSTOMER_PAYABLE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.customerPayable.loading = LoadState.InProgress;
        draftState.customerPayable.list = [];
        draftState.customerPayable.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_RECON_CUSTOMER_PAYABLE_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.customerPayable.loading = LoadState.Loaded;
        draftState.customerPayable.list = data;
        draftState.customerPayable.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_RECON_CUSTOMER_PAYABLE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.customerPayable.loading = LoadState.InProgress;
        draftState.customerPayable.list = [];
        draftState.customerPayable.totalRecords = 0;
      });
      return newState;
    }
      case FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.duplicateTransactionItems.loading = LoadState.InProgress;
        draftState.duplicateTransactionItems.list = [];
      });
      return newState;
    }
    case FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.duplicateTransactionItems.loading = LoadState.Loaded;
        draftState.duplicateTransactionItems.list = data;
      });
      return newState;
    }
    case FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.duplicateTransactionItems.loading = LoadState.InProgress;
        draftState.duplicateTransactionItems.list = [];
      });
      return newState;
    }
    case UPDATE_INVOICE_PAYMENT_TRANSACTION_RECONCILIATION_STATUS: {
      const { paymentIds, reconciled, reconciledDate } = action.payload;
      return produce(state, (draftState) => {
        paymentIds.forEach((id: number) => {
          const index = draftState.agencyBill.list.findIndex(x => x.accn_invoice_payment_transaction_items_id === id);
          if (index > -1) {
            draftState.agencyBill.list[index].reconciled = reconciled;
            draftState.agencyBill.list[index].reconciled_date = reconciledDate;
          }
        });
      });
    }
    case UPDATE_BILL_PAYMENT_RECONCILIATION_STATUS: {
      const { payment_id, reconciled, reconciledDate } = action.payload;
      return produce(state, (draftState) => {
        payment_id.forEach((id: number) => {
          const index = draftState.directBill.list.findIndex(x => x.accn_create_payment_id === id);
          if (index > -1) {
            draftState.directBill.list[index].reconciled = reconciled;
            draftState.directBill.list[index].reconciled_date = reconciledDate;
          }
        });
      });
    }
    case CLEAR_RECONCILIATION_STATE: {
      return initialReconciliationState;
    }

    default: {
      return state;
    }
  }
};
